import { render, staticRenderFns } from "./Rappers.vue?vue&type=template&id=28948040&scoped=true&"
import script from "./Rappers.vue?vue&type=script&lang=js&"
export * from "./Rappers.vue?vue&type=script&lang=js&"
import style0 from "./Rappers.vue?vue&type=style&index=0&id=28948040&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28948040",
  null
  
)

export default component.exports